<div mat-dialog-title>
    <h2>{{"content2." + (isUpdate ? 'Update' : 'Add New') + " Floor" | translate}}</h2>
    <button mat-icon-button (click)="openConfirmDialog()" class="close">
      <mat-icon class="pop-close">close</mat-icon>
    </button>
  </div>
  <form [formGroup]="formGroup">
    <mat-dialog-content>
      <div class="mat-dialog-body">
        <div class="fields-group">
          <mat-form-field class="mb-2" hideRequiredMarker>
            <mat-label>{{"forms.Name in English" | translate}}</mat-label>
            <input matInput formControlName="title_EN" maxlength="20">
            <mat-error *ngIf="hasError('title_EN', 'required')">{{ 'forms.Required' | translate }}</mat-error>
            <!-- <mat-error *ngIf="hasError('title_EN', 'pattern')">
              {{ 'forms.EntervalidNameinEnglish' | translate }}
            </mat-error> -->
          </mat-form-field>

          <mat-form-field class="mb-2" hideRequiredMarker>
            <mat-label>{{"forms.Name in Arabic" | translate}}</mat-label>
            <input matInput formControlName="title_AR" maxlength="20">
            <mat-error *ngIf="hasError('title_AR', 'required')">{{ 'forms.Required' | translate }}</mat-error>
            <!-- <mat-error *ngIf="hasError('title_AR', 'pattern')">
              {{ 'forms.EntervalidNameinArabic' | translate }}
            </mat-error> -->
          </mat-form-field>
        </div>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions>
      <button mat-button type="button" (click)="openConfirmDialog()" class="btn-grey">
        {{"forms.Cancel" | translate}}
      </button>
      <button mat-raised-button color="primary" (click)="saveRecord()" [disabled]="loading" [class.loading]="loading">
        <span *ngIf="!isUpdate">{{"forms.Continue" | translate}}</span>
        <span *ngIf="isUpdate">{{"forms.Update" | translate}}</span>
      </button>
    </mat-dialog-actions>
  </form>
